import DocumentDownloadCTA, {
    DocumentDownloadCTASkeleton,
    type Props,
} from "./DocumentDownloadCTA";

export default DocumentDownloadCTA;

export { DocumentDownloadCTASkeleton, type Props };
